import React from 'react'
import { StyleSheet, View } from 'react-native'
import { Icon } from '../atoms/Icon'
import { Theme } from '@theme'
import { useTheme } from '@react-navigation/native'

interface CheckBoxProps {
  isChecked: boolean
  multiSelect?: boolean
}

export const CheckBox: React.FC<CheckBoxProps> = ({ isChecked, multiSelect = true }) => {
  const theme = useTheme()
  const styles = getStyle(theme)
    
  return (
    <View style={[
        styles.checkbox, 
        isChecked && styles.checkboxSelected,
      ]}>
        {isChecked && (
          <Icon 
            name="check" 
            size={14} 
            color={theme.colors.white} 
          />
        )}
      </View>
  )
}

const getStyle = (theme: Theme) =>
    StyleSheet.create({
      container: {
        width: '100%',
      },
      header: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginBottom: theme.spacing.sm,
      },
      closeButton: {
        position: 'absolute',
        top: -theme.spacing.xxl/2,
        right: 0,
        padding: theme.spacing.xs,
      },
      titleContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: theme.spacing.xxxl,
        gap: theme.spacing.lg,
      },
      title: {
        textAlign: 'center',
        color: theme.colors.secondary,
      },
      addCategoryButton: {
        borderRadius: 20,
        backgroundColor: theme.colors.primary + 20,
        padding: theme.spacing.xs,
      },
      selectionCount: {
        textAlign: 'left',
        marginTop: theme.spacing.lg,
        color: theme.colors.greyBlue,
        fontSize: theme.fontSize.small,
      },
      itemsList: {
        maxHeight: 400,
        width: '100%',
        marginTop: theme.spacing.lg,
      },
      item: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: theme.spacing.md,
        borderBottomWidth: 1,
        borderBottomColor: theme.colors.lightGrey,
      },
      lastItem: {
        borderBottomWidth: 0,
      },
      itemContent: {
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
      },
      flag: {
        fontSize: theme.fontSize.large,
        marginRight: theme.spacing.sm,
      },
      itemPhoto: {
        width: 50,
        height: 50,
        borderRadius: 25,
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing.lg,
      },
      itemName: {
        flex: 1,
      },
      checkbox: {
        width: 20,
        height: 20,
        borderWidth: 2,
        borderColor: theme.colors.lightGrey,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.colors.white,
        borderRadius: 20,
      },
      checkboxSelected: {
        backgroundColor: theme.colors.primary,
        borderColor: theme.colors.primary,
      },
      selectionBar: {
        height: 40,
        width: 6,
        borderRadius: 3,
        backgroundColor: theme.colors.white,
        marginLeft: theme.spacing.md,
      },
      selectionBarActive: {
        backgroundColor: theme.colors.primary,
      },
    }) 